import { useShallow } from "zustand/react/shallow";
import { useAuthStore } from "../stores/auth";

export function useAuth() {
  return useAuthStore(
    useShallow((state) => ({
      session: state.session,
      user: state.user,
      isAuthenticated: Boolean(state.session),
      isLoading: state.isLoading,
      signOut: state.signOut,
    })),
  );
}
